const environment = "Dev"; export default environment;
